export const isEllipsisActive = (element: Element) => element.scrollWidth > element.clientWidth;
